import React from 'react';

const Footer = () => {
    return(
        <section className="footer">
            <div className="footer-contacts">
                <div className="contact">
                    <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                    <span className="info"><a href="tel:2013286323" className="no-decoration"> 201-328-6323 </a> <br/>
                    </span>

                </div>
                <div className="contact">
                    <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                    <span className="info"> ipwd.usa@gmail.com </span>
                </div>
                <div className="contact">
                    <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path></svg>
                    <span className="info"> <a href="https://www.google.com/maps/dir//2030+Hudson+St+Fort+Lee,+NJ+07024/@40.8519844,-73.9684975,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x89c2f6c401c9f7fb:0x8afb3316126a8d7a" className="no-decoration">2030 Hudson Street </a></span>
                </div>
                <div className="contact succ">
                    <span className="info-cont"> <a href="https://www.google.com/maps/dir//2030+Hudson+St+Fort+Lee,+NJ+07024/@40.8519844,-73.9684975,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x89c2f6c401c9f7fb:0x8afb3316126a8d7a" className="no-decoration">Fort Lee, NJ 07024 </a></span>
                </div>
            </div>
        </section>
    )
}

export default Footer;